import React from 'react';
import { Itinerary as ItineraryType } from '@kiwicom/openapi-sdk/mmb';
import OrbitItinerary from '@kiwicom/orbit-components/lib/Itinerary';

import Sector from './components/Sector';
import useOpenHelpArticle, { TrackingProps } from './services/hooks/useOpenHelpArticle';
import { ItineraryContext } from './services/context/itineraryContext';
import { ThrowAwayBannerAction } from './services/types';

type ItineraryProps = {
  itinerary: ItineraryType;
  trackingProps: TrackingProps;
  throwAwayBannerAction?: ThrowAwayBannerAction;
  tatModalDescription: React.ReactNode;
};

/**
 * Component for rendering server-driven Itinerary
 *
 * @param itinerary - {@link ItineraryType} object coming from backend
 * @param trackingProps - an object containing data tracked when a SmartFAQ article is opened
 * @param throwAwayBannerAction - an action to be performed when a throwaway ticket banner is clicked
 * @param tatModalDescription - a description of the throwaway ticket modal
 *
 * @returns Itinerary component
 */
const Itinerary = ({
  itinerary,
  trackingProps,
  throwAwayBannerAction = ThrowAwayBannerAction.showModal,
  tatModalDescription,
}: ItineraryProps) => {
  const ref = useOpenHelpArticle<HTMLDivElement>(trackingProps);
  return (
    <div ref={ref}>
      <ItineraryContext.Provider
        value={{
          throwAwaySectors: itinerary.throwawaySectors,
          throwAwayBannerAction,
          tatModalDescription,
        }}
      >
        <OrbitItinerary dataTest="Itinerary">
          {itinerary.sectors.map((sector, sectorIndex) => (
            // eslint-disable-next-line react/no-array-index-key
            <Sector key={sectorIndex} sector={sector} />
          ))}
        </OrbitItinerary>
      </ItineraryContext.Provider>
    </div>
  );
};

export default Itinerary;
